import { useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import React from 'react'

import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import ServiceOrdersTable from './table/ServiceOrdersTable'

const PageContent = () => {
  // usePageTitle('Atividades')
  const filter = useCleanFilterForRequest()
  const { search, searchType } = useFilterState()

  return (
    <MultiSelectHandler>
      <ServiceOrdersLoader
        uncontrolledChildren={<MultiRowsActions />}
        search={search}
        searchType={searchType}
        filter={filter}
      >
        <ServiceOrdersTable />
      </ServiceOrdersLoader>
    </MultiSelectHandler>
  )
}

export default PageContent
